import canonical from 'components/seo/canonical';
import description from 'components/seo/description';
import image from 'components/seo/image';
import robots from 'components/seo/robots';
import title from 'components/seo/title';
import seotype from 'components/seo/type';
import { useConfig } from 'config/use-config';
import { IProductPages } from 'global';
import Head from 'next/head';
import { FC } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { Organization } from 'schema-dts';

const HomeHead: FC<{ contentfulData: IProductPages }> = ({ contentfulData }) => {
  const { legalName, supportEmail, customerHotline } = useConfig();
  const { headline, metaDescription, metaRobots, metaOgImage } = contentfulData.fields;

  return (
    <Head>
      {title(headline)}
      {description(metaDescription)}
      {seotype()}
      {robots(metaRobots)}
      {canonical('/')}
      {image(metaOgImage?.fields.file.url)}
      <script
        {...jsonLdScriptProps<Organization>({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          '@id': '#organization',
          sameAs: [
            'https://www.facebook.com/petsdeli',
            'https://www.instagram.com/petsdeli',
            'https://www.pinterest.de/petsdeli',
            'https://www.linkedin.com/company/pets-deli',
          ],
          name: 'Pets Deli',
          url: 'https://www.petsdeli.de',
          legalName,
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Winsstr. 62',
            addressLocality: 'Berlin',
            addressRegion: 'DE-BE',
            addressCountry: 'GER',
            postalCode: '10405',
          },
          logo: {
            '@type': 'ImageObject',
            caption: 'Pets Deli',
            url: 'https://www.petsdeli.de/images/petsdeli-logo.svg',
          },
          foundingDate: '2017',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: `+${customerHotline}`,
            email: supportEmail,
            contactType: 'Customer Support',
          },
        })}
        data-test="organization-schema"
      />
    </Head>
  );
};

export default HomeHead;
